import { render } from "./Proposal.vue?vue&type=template&id=22457c48"
import script from "./Proposal.vue?vue&type=script&lang=js"
export * from "./Proposal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/wallace/Desktop/projects/virtap/virtap-webapp-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__